<template>
    <div class="lottie-wrapper">
      <lottie :options="defaultOptions" v-on:animCreated="handleAnimation"/>
    </div>
</template>

<script>
import Lottie from 'vue-lottie';

export default {
  components: {
    'lottie': Lottie
  },
  props: {
    data: [Object, String]
  },
  data() {
    return {
      defaultOptions: {
        animationData: this.data,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          progressiveLoad: true
        }
      },
      animationSpeed: 1
    }
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },

    // stop: function () {
    //   this.anim.stop();
    // },

    // play: function () {
    //   this.anim.play();
    // },

    // pause: function () {
    //   this.anim.pause();
    // },

    // onSpeedChange: function () {
    //   this.anim.setSpeed(this.animationSpeed);
    // }
  }
}
</script>
